import { loadLibraries } from "./libraries";
import type { LatLng, LatLngBounds } from "./types";

export const getZipCodeFromLatLng = async (apiKey: string, location: LatLng, bounds: LatLngBounds): Promise<string> => {
  const { geocodingLibrary } = await loadLibraries(apiKey);

  const geocoding = new geocodingLibrary.Geocoder();

  const result = await geocoding.geocode({
    location,
    bounds,
  });

  let postalCode = null;

  for (const location of result.results) {
    postalCode = location.address_components?.find((f) => isPostalCode(f.types));

    if (postalCode) {
      break;
    }
  }

  if (!postalCode) {
    throw new Error("No postal code in this area");
  }

  return postalCode?.long_name;
};

const isPostalCode = (types: string[]) => {
  for (const type of types) {
    if (type !== "postal_code") {
      return false;
    }
  }

  return true;
};
